import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../../../../../components/ui/dialog";
import { Button } from "../../../../../../components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../../../components/ui/tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../../../../components/ui/select";
import { AlertTriangle, ChevronLeft, Save, X, Download, Loader2 } from "lucide-react";
import { Fitment } from "./Fitment";
import { VisualInspection } from "./VisualInspection";
import { useTeamMembers } from "../../../../../../redux/ProductionData/hooks/useTeamMembers";
import { updateAssemblyFitment, updateAssemblyVisualInspection, updateAssemblyAlignment, downloadFitmentReport, clearFitmentReportDownload, downloadVisualInspectionReport, clearVisualInspectionReportDownload, downloadAlignmentReport, clearAlignmentReportDownload, fetchProductionData } from "../../../../../../redux/ProductionData/actions";
import { useDispatch, useSelector } from "react-redux";
//import { DeleteConfirmationDialog } from "../../../../../../components/ui/DeleteConfirmationDialog";
//import { useTeamMembersRedux } from "../../../../../../redux/TeamMembers/hooks/useTeamMembersRedux";
import { useProductionData } from "../../../../../../redux/ProductionData/hooks/useProductionData";
import { SpecificationDocument, TeamMember } from "../../../../types";
import { Notification as customNotification } from '../../../../../../components/ui/custom-notification';
import { Alignment } from './Alignment';
import axiosConfig from "../../../../../../redux/ProductionData/axiosConfig";
import { DocumentApprovalModal } from '../DocumentApprovalModal';
import { PdfViewer } from '../../../../../../components/viewers/PdfViewer';
import { MediaViewer } from '../../../../../../components/viewers/MediaViewer';
import { DocumentViewer } from '../../../../../../components/viewers/DocumentViewer';
interface FitmentVisualInspectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedItem: any;
    selectedPipe: any;
    materials: any;
    productionSheetData?: any;
    type: 'fitment' | 'visualInspection' | 'alignment';
    canEdit?: boolean;
    canReport?: boolean;
    canSign?: boolean;
    isCustomerRepresentativeUser?: boolean;
    isQCInspectorUser?: boolean;
    currentUserTeamMemberId?: string | number;
    isAdminOrSuperAdmin?: boolean;
}

export const FitmentVisualInspectionModal: React.FC<FitmentVisualInspectionModalProps> = ({
    isOpen,
    onClose,
    selectedItem,
    selectedPipe,
    canEdit = false,
    canReport = false,
    canSign = false,
    materials,
    type,
    isCustomerRepresentativeUser = false,
    isQCInspectorUser = false,
    currentUserTeamMemberId,
    isAdminOrSuperAdmin = false
}) => {
    const dispatch = useDispatch();


    const [productionSheetData, setProductionSheetData] = useState<any>(null);
    const [activeTab, setActiveTab] = useState<'weld1' | 'weld2'>('weld1');
    const [selectedRepairWeld, setSelectedRepairWeld] = useState<string>('default');
    const [selectedRepairAlignment, setSelectedRepairAlignment] = useState<string>('default');
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isDocumentApprovalModalOpen, setIsDocumentApprovalModalOpen] = useState(false);


    // Get Redux state for save status
    const fitmentUpdateLoading = useSelector((state: any) => state.productionData?.fitmentUpdateLoading);
    const fitmentUpdateError = useSelector((state: any) => state.productionData?.fitmentUpdateError);
    const fitmentUpdateSuccess = useSelector((state: any) => state.productionData?.fitmentUpdateSuccess);

    const visualInspectionUpdateLoading = useSelector((state: any) => state.productionData?.visualInspectionUpdateLoading);
    const visualInspectionUpdateError = useSelector((state: any) => state.productionData?.visualInspectionUpdateError);
    const visualInspectionUpdateSuccess = useSelector((state: any) => state.productionData?.visualInspectionUpdateSuccess);

    // Get Redux state for alignment save status
    const alignmentUpdateLoading = useSelector((state: any) => state.productionData?.alignmentUpdateLoading);
    const alignmentUpdateError = useSelector((state: any) => state.productionData?.alignmentUpdateError);
    const alignmentUpdateSuccess = useSelector((state: any) => state.productionData?.alignmentUpdateSuccess);

    // Get Redux state for fitment report download
    const fitmentReportDownloadLoading = useSelector((state: any) => state.productionData?.fitmentReportDownloadLoading);
    const fitmentReportDownloadData = useSelector((state: any) => state.productionData?.fitmentReportDownloadData);
    const fitmentReportDownloadError = useSelector((state: any) => state.productionData?.fitmentReportDownloadError);

    // Get Redux state for visual inspection report download
    const visualInspectionReportDownloadLoading = useSelector((state: any) => state.productionData?.visualInspectionReportDownloadLoading);
    const visualInspectionReportDownloadData = useSelector((state: any) => state.productionData?.visualInspectionReportDownloadData);
    const visualInspectionReportDownloadError = useSelector((state: any) => state.productionData?.visualInspectionReportDownloadError);

    // Get Redux state for alignment report download
    const alignmentReportDownloadLoading = useSelector((state: any) => state.productionData?.alignmentReportDownloadLoading);
    const alignmentReportDownloadData = useSelector((state: any) => state.productionData?.alignmentReportDownloadData);
    const alignmentReportDownloadError = useSelector((state: any) => state.productionData?.alignmentReportDownloadError);

    // State for fitment data
    const [fitmentWeld1Data, setFitmentWeld1Data] = useState<any>(null);
    const [fitmentWeld2Data, setFitmentWeld2Data] = useState<any>(null);

    // State for visual inspection data
    const [visualInspectionWeld1Data, setVisualInspectionWeld1Data] = useState<any>(null);
    const [visualInspectionWeld2Data, setVisualInspectionWeld2Data] = useState<any>(null);

    // State for alignment data
    const [alignmentWeldData, setAlignmentWeldData] = useState<any>(null);
    const [alignmentState, setAlignmentState] = useState<any>({
        notes: "",
        customerSignature: null,
        qcSignature: null,
    });
    const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
    const [showEditConfirmation, setShowEditConfirmation] = useState(false);

    // Viewer state management
    const [viewerType, setViewerType] = useState<'pdf' | 'media' | 'document' | null>(null);
    const [viewerFile, setViewerFile] = useState<any | null>(null);
    const [viewerFiles, setViewerFiles] = useState<any[]>([]);

    // Team members state
    const [qcList, setQcList] = useState<Array<{ value: string; name: string; label: string }>>([]);
    const [customerRepresentativeList, setCustomerRepresentativeList] = useState<Array<{ value: string; name: string; label: string }>>([]);
    const [specifications, setSpecifications] = useState<SpecificationDocument[]>([]);

    // Ref to track the last project ID we fetched team members for
    const lastFetchedProjectId = useRef<string | null>(null);
    // Tracks whether the next productionSheetData change is the initial modal open (should reset selections)
    const isInitialOpenRef = useRef<boolean>(true);

    // Hooks for team members and production data
    const { teamMembers, loadTeamMembers, teamMembersLoading, teamMembersError } = useTeamMembers();
    //const { teamMembers, error: teamMembersError, fetchTeamMembers, loading: teamMembersLoading } = useTeamMembersRedux();
    //const { assemblyError: productionDataError, assemblyData: productionData } = useProductionData();
    // Get Redux state for production data
    const productionData = useSelector((state: any) => state.productionData?.productionData);
    const productionDataError = useSelector((state: any) => state.productionData?.productionDataError);
    const productionDataSuccess = useSelector((state: any) => state.productionData?.productionDataSuccess);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [isReportLoading, setIsReportLoading] = useState(false);


    const mockSelectedHeadings = {
        wps: { label: "WPS Document" },
        drawing: { label: "Drawing Document" },
        forge: { label: "Forge Material" },
        pipe: { label: "Pipe Material" },
        wire: [{ label: "Wire Lot" }],
        gas: [{ label: "Gas Material" }],
        welder1: { label: "Welder 1" },
        welder2: { label: "Welder 2" }
    };
  // For repair welds (repairindex > 0) that share the same weldindex,
        // keep only the entry with the highest productionWeldId (the latest repair).
        // Regular welds (repairindex === 0) are always kept as-is.
        const deduplicateRepairWelds = (welds: any) => {
            if (!Array.isArray(welds)) return welds ?? [];
            const regular = welds.filter(w => w.repairindex === 0);
            const repairs  = welds.filter(w => w.repairindex > 0);
  
            const latestByWeldIndex: any = {};
            repairs.forEach(w => {
              const key = w.weldindex;
              if (!latestByWeldIndex[key] || w.productionWeldId < latestByWeldIndex[key].productionWeldId) {
                latestByWeldIndex[key] = w;
              }
            });
  
            return [...regular, ...Object.values(latestByWeldIndex)];
          };
  
     
    useEffect(() => {
        if (productionData && productionData.length > 0) {
            const existingData = productionData[0] as any; // Take the first item if array
            const productionSheet = existingData.productionSheet;
            if (productionSheet) {
                const transformedProductionSheet = deduplicateRepairWelds(productionSheet?.productionWelds);
                setProductionSheetData({...productionSheet, productionWelds: transformedProductionSheet});
                console.log('transformedProductionSheet', transformedProductionSheet);
                initializeData({...productionSheet, productionWelds: transformedProductionSheet});
                loadtetAllTeamMembers();
                setActiveTab('weld1');
            }
        } else if (!productionData && selectedItem?.productionSheet) {
            // Fallback to prop if API data is not available
            const transformedProductionSheet = deduplicateRepairWelds(selectedItem.productionSheet?.productionWelds);
            setProductionSheetData({...selectedItem.productionSheet, productionWelds: transformedProductionSheet});
      
            console.log('transformedProductionSheet', transformedProductionSheet);
        }
    }, [productionData]);

    const loadProductionData = async () => {
        // Use actual project ID from props instead of selectedItem
        const projectId = selectedItem?.projectId || selectedPipe?.projectId;
        const pipeId = selectedItem?.pipeId || selectedPipe?.pipeId || selectedPipe?.id;
        // Get productionId from multiple sources - prioritize selectedItem.productionSheet, then selectedItem, then state
        const productionId = selectedItem?.productionId


        if (projectId && pipeId && productionId) {
            try {
                setIsLoadingData(true);
                await dispatch(fetchProductionData({
                    projectId: projectId,
                    pipe_id: pipeId,
                    production_id: productionId
                }));
            } catch (error) {
                customNotification.error('Failed to load production data');
            } finally {
                setIsLoadingData(false);
            }
        } else {
            console.warn('Missing required IDs for loadProductionData:', { projectId, pipeId, productionId, selectedItem });
        }
    };

    // Initialize data when modal opens
    useEffect(() => {
        if (isOpen) {
            isInitialOpenRef.current = true;
            loadTeamMembers(selectedItem.projectId);
        
            // Initialize from prop first, then load fresh data
            if (selectedItem?.productionSheet) {
                const transformedProductionSheet = deduplicateRepairWelds(selectedItem.productionSheet.productionWelds);
                setProductionSheetData({...selectedItem.productionSheet, productionWelds: transformedProductionSheet});
           
           console.log('transformedProductionSheet', transformedProductionSheet);
            }
            else
                loadProductionData();
        }

    }, [isOpen]);

    // Reset selected repair weld when active tab changes
    useEffect(() => {
        setSelectedRepairWeld('default');
    }, [activeTab]);

    // Reset selected repair alignment when modal opens or type changes
    useEffect(() => {
        if (isOpen && type === 'alignment') {
            // Only reset the repair selection on initial open, not after saves
            if (isInitialOpenRef.current) {
                setSelectedRepairAlignment('default');
            }
            // Use UpdateAlignmentData to properly initialize default alignment
            if (productionSheetData?.productionAlignment) {
                UpdateAlignmentData(productionSheetData);
            } else {
                setAlignmentWeldData(null);
            }
        }
    }, [isOpen, type, productionSheetData]);

    // Initialize data when modal opens
    useEffect(() => {
        if (isOpen && productionSheetData) {

            initializeData(productionSheetData);
            // Only reset selections on initial open, not on data refreshes after save/report
            if (isInitialOpenRef.current) {
                setSelectedRepairWeld('default');
                isInitialOpenRef.current = false;
            }
            setHasUnsavedChanges(false);
            // Set initial edit mode based on signatures - if no signatures, allow editing by default
            // We'll check this after data is initialized
        }

        // Reset the last fetched project ID when modal closes
        if (!isOpen) {
            lastFetchedProjectId.current = null;
            setIsEditMode(false);
            setSelectedRepairWeld('default');
            setSelectedRepairAlignment('default');
        }
    }, [productionSheetData]);

    // Set initial edit mode based on signatures after data is loaded
    useEffect(() => {
        if (productionSheetData) {
            // Check if signatures exist - if not, allow editing by default
            const signaturesExist = hasSignatures();
            //     console.log('signaturesExist', signaturesExist);
            setIsEditMode(!signaturesExist); // If no signatures, enable edit mode; if signatures exist, disable it
        }
    }, [isOpen, fitmentWeld1Data, fitmentWeld2Data, visualInspectionWeld1Data, visualInspectionWeld2Data, alignmentWeldData, activeTab, type, productionSheetData]);

    // // Debug effect to track list changes
    // useEffect(() => {
    //     console.log('QC List changed:', qcList);
    //     console.log('Customer List changed:', customerRepresentativeList);
    // }, [qcList, customerRepresentativeList]);

    // Listen for save success/failure
    useEffect(() => {
        if (fitmentUpdateError) {
            customNotification.error(fitmentUpdateError || 'Failed to save fitment data');
        }
    }, [fitmentUpdateError]);

    // Helper functions to check signatures for each type
    const hasFitmentSignatures = () => {
        if (type !== 'fitment') return false;
        const weld1HasSignatures = fitmentWeld1Data?.signature?.qc?.signature && fitmentWeld1Data?.signature?.customer?.signature;
        const weld2HasSignatures = fitmentWeld2Data?.signature?.qc?.signature && fitmentWeld2Data?.signature?.customer?.signature;
        // Check the active tab's weld for signatures
        return activeTab === 'weld1' ? weld1HasSignatures : weld2HasSignatures;
    };

    const hasVisualInspectionSignatures = () => {
        if (type !== 'visualInspection') return false;
        const weld1HasSignatures = visualInspectionWeld1Data?.signature?.qc?.signature && visualInspectionWeld1Data?.signature?.customer?.signature;
        const weld2HasSignatures = visualInspectionWeld2Data?.signature?.qc?.signature && visualInspectionWeld2Data?.signature?.customer?.signature;
        // Check the active tab's weld for signatures
        return activeTab === 'weld1' ? weld1HasSignatures : weld2HasSignatures;
    };

    const hasAlignmentSignatures = () => {
        if (type !== 'alignment') return false;
        return alignmentWeldData?.signature?.qc?.signature && alignmentWeldData?.signature?.customer?.signature;
    };

    useEffect(() => {
        if (isSaveLoading && fitmentUpdateSuccess) {
            const weldData = activeTab === 'weld1' ? fitmentWeld1Data : fitmentWeld2Data;
            if (weldData && hasFitmentSignatures()) {
                handleDownloadFitmentReport(weldData);
            }
            setIsSaveLoading(false)
            loadProductionData();
        }
    }, [fitmentUpdateSuccess]);
    useEffect(() => {
        if (isSaveLoading && visualInspectionUpdateSuccess) {
            const weldData = activeTab === 'weld1' ? visualInspectionWeld1Data : visualInspectionWeld2Data;
            if (weldData && hasVisualInspectionSignatures()) {
                handleDownloadVisualInspectionReport(weldData);
            }
            setIsSaveLoading(false)
            loadProductionData();
        }
    }, [visualInspectionUpdateSuccess]);

    useEffect(() => {
        if (isSaveLoading && alignmentUpdateSuccess) {
            if (alignmentWeldData && hasAlignmentSignatures()) {
                handleDownloadAlignmentReport();
            }
            setIsSaveLoading(false)
            loadProductionData();
        }
    }, [alignmentUpdateSuccess]);

    useEffect(() => {
        if (visualInspectionUpdateError) {
            customNotification.error(visualInspectionUpdateError || 'Failed to save visual inspection data');
        }
    }, [visualInspectionUpdateError]);

    useEffect(() => {
        if (alignmentUpdateError) {
            customNotification.error(alignmentUpdateError || 'Failed to save alignment data');
        }
    }, [alignmentUpdateError]);

    useEffect(() => {
        if (fitmentUpdateSuccess || visualInspectionUpdateSuccess || alignmentUpdateSuccess) {
            // customNotification.success(type === 'fitment' ? 'Fitment data saved successfully' : 'Visual inspection data saved successfully');
            //setHasUnsavedChanges(false);
            //  console.log('fitmentUpdateSuccess', fitmentUpdateSuccess);
            // After save, check if signatures exist - if they do, disable edit mode; if not, keep it enabled
            const signaturesExist = hasSignatures();
            setIsEditMode(!signaturesExist);
            // Don't close modal automatically - let user close it manually
            // onClose();
            //  customNotification.success(type === 'fitment' ? 'Fitment data saved successfully' : 'Visual inspection data saved successfully');
        }
    }, [fitmentUpdateSuccess, visualInspectionUpdateSuccess, alignmentUpdateSuccess, type, fitmentWeld1Data, fitmentWeld2Data, visualInspectionWeld1Data, visualInspectionWeld2Data, alignmentWeldData, activeTab]);






    const UpdateAlignmentData = (productionSheetData: any) => {
        const alignmentData = productionSheetData?.productionAlignment ? { ...productionSheetData?.productionAlignment } : {};

        alignmentData.productionId = productionSheetData?.productionId;
        alignmentData.projectId = selectedPipe?.projectId;
        alignmentData.projectTypeId = selectedPipe?.projectTypeId;
        alignmentData.pipeId = selectedPipe?.pipeId;
        if (!alignmentData.details) {
            alignmentData.details = {};
        }

        setAlignmentWeldData(alignmentData);
        return alignmentData;
    };


    const UpdateRepairAlignmentData = (weldindex: number, repairindex: number) => {
        console.log('weldindex', weldindex);
        console.log('repairindex', repairindex);
    
        // Find existing repair alignment from productionSheetData or repairAlignments state
        let alignmentData = productionSheetData?.productionRepairAlignments?.find((ra: any) => ra.repairindex === repairindex)
    
        //console.log(' existing alignmentData', alignmentData);
    
        if (!alignmentData) {
          alignmentData = {}
          // Set required properties
          alignmentData.productionId = productionSheetData?.productionId;
          alignmentData.projectId = selectedPipe?.projectId;
          alignmentData.projectTypeId = selectedPipe?.projectTypeId;
          alignmentData.pipeId = selectedPipe?.pipeId;
          alignmentData.repairindex = repairindex;
    
          if (!alignmentData.details) {
            alignmentData.details = {};
          }
          // productionSheetData?.productionRepairAlignments?.push(alignmentData);
          // Update repairAlignments state if it doesn't exist
          // setRepairAlignments([...productionSheetData?.productionRepairAlignments]);
        }
        // console.log('alignmentData', alignmentData);
    
        console.log('alignmentData', alignmentData);
        // Set alignmentWeldData so Alignment component can use it
        setAlignmentWeldData(alignmentData);
    
        return alignmentData;
      }
    

    const initializeData = (productionSheetData: any) => {
        setIsLoadingData(true);
        if (productionSheetData?.productionWelds) {

            if (selectedPipe?.documentsData?.documents && Array.isArray(selectedPipe.documentsData.documents)) {
                const newSpecifications: SpecificationDocument[] = selectedPipe.documentsData.documents.map((doc: any) => ({
                    id: doc.docRefId?.toString(),
                    fileName: doc.fileName || '',
                    type: doc.type as SpecificationDocument['type'],
                    pipeId: selectedPipe?.pipeId?.toString(),
                    projectId: selectedPipe?.projectId,
                    projectTypeId: selectedPipe?.projectTypeId,
                    pipeOrder: selectedPipe?.pipeOrder || 0,
                    fileUrl: doc.fileUrl,
                    s3Key: doc.s3Key,
                    uploadedBy: doc.uploadedBy,
                    uploadDate: doc.uploadDate,
                    version: doc.version || 1,
                    details: doc.details || {},
                    files: doc.files || [],
                    docRefId: doc.docRefId || 0
                }));


                setSpecifications(newSpecifications);
            } else {
            }



            const weld1 = productionSheetData.productionWelds[0];
            // console.log('weld1', weld1);
            const weld2 = productionSheetData.productionWelds[1];

            if (type === 'fitment') {
                if (weld1?.weldFitment) {
                    if (!weld1.weldFitment.details)
                        weld1.weldFitment.details = {};

                    setFitmentWeld1Data({
                        ...weld1.weldFitment,
                        productionId: productionSheetData.productionId
                    });
                }
                if (weld2?.weldFitment) {
                    if (!weld2.weldFitment.details)
                        weld2.weldFitment.details = {};
                    setFitmentWeld2Data({
                        ...weld2.weldFitment,
                        productionId: productionSheetData.productionId
                    });
                }
            } else if (type === 'visualInspection') {
                if (weld1?.weldVisualInspection) {
                    setVisualInspectionWeld1Data({
                        ...weld1.weldVisualInspection,
                        productionId: productionSheetData.productionId
                    });
                }
                if (weld2?.weldVisualInspection) {
                    setVisualInspectionWeld2Data({
                        ...weld2.weldVisualInspection,
                        productionId: productionSheetData.productionId
                    });
                }
            } else if (type === 'alignment') {
                // Initialize alignment data
                UpdateAlignmentData(productionSheetData);
            }
        } else if (type === 'alignment' && productionSheetData) {
            // Handle case where there's no productionWelds but we have productionSheetData
            UpdateAlignmentData(productionSheetData);
        } else if (type === 'alignment') {
            // Handle case where there's no productionSheetData at all - create empty structure
            const emptyAlignmentData = {
                productionId: selectedPipe?.productionId,
                projectId: selectedPipe?.projectId,
                projectTypeId: selectedPipe?.projectTypeId,
                pipeId: selectedPipe?.pipeId,
                details: {},
                alignmentReadings: []
            };
            setAlignmentWeldData(emptyAlignmentData);
        }
        setIsLoadingData(false);
    };




    //   // Load team members when selectedItem changes - only when projectId changes
    // useEffect(() => {

    //   if (selectedItem?.projectId) {
    //     const currentProjectId = selectedItem.projectId;

    //     // Only fetch if we haven't already fetched for this project ID and not currently loading
    //     if (lastFetchedProjectId.current !== currentProjectId && !teamMembersLoading ) {
    //       fetchTeamMembers(currentProjectId);
    //       lastFetchedProjectId.current = currentProjectId;
    //     } else if (lastFetchedProjectId.current === currentProjectId) {
    //     } else if (teamMembersLoading) {
    //     }
    //   }
    // }, [selectedItem?.projectId, fetchTeamMembers]);

    // Load team members when selectedItem changes
    // useEffect(() => {
    //     //  console.log('Team members loading effect triggered, selectedItem:', selectedItem);
    //     if (isOpen && selectedItem?.projectId) {
    //         //  console.log('Loading team members for project:', selectedItem.projectId);
    //         loadTeamMembers(selectedItem.projectId);
    //     } else {
    //         //  console.log('No project ID available for team members loading');
    //     }
    // }, [isOpen]);

    // Handle production data loading and error states
    useEffect(() => {
        if (productionDataError) {
            customNotification.error(productionDataError || 'Failed to load production data');
        }
    }, [productionDataError]);

    // Handle team members loading and error states
    useEffect(() => {
        if (teamMembersError) {
            customNotification.error(teamMembersError || 'Failed to load team members');
        }
    }, [teamMembersError]);

    const loadtetAllTeamMembers = async () => {
        if (teamMembers) {

            const qcInspectors = teamMembers
                .filter((member: any) => member?.team_member_role === 'Quality Control' || member?.team_member_role === 'QC' || member?.team_member_role === 'QA/QC')
                .map((member: any) => ({
                    value: member.team_member_id.toString(),
                    name: `${member.user.first_name} ${member.user.last_name}`,
                    label: `${member.user.first_name} ${member.user.last_name} (${member.user.email})`,
                    userId: member?.user_id
                }));



            const customerReps = teamMembers
                .filter((member: any) => member?.team_member_role === 'Customer Representative' || member?.team_member_role === 'Client Representative' && member?.user_id === currentUserTeamMemberId)
                .map((member: any) => ({
                    value: member.team_member_id.toString(),
                    name: `${member.user.first_name} ${member.user.last_name}`,
                    label: `${member.user.first_name} ${member.user.last_name} (${member.user.email})`,
                    userId: member?.user_id
                }));

            //console.log('QC Inspectors:', qcInspectors);
            // console.log('Customer Reps:', customerReps);
            if (isAdminOrSuperAdmin) {
                setQcList(qcInspectors);
            }
            else if (isQCInspectorUser && qcInspectors.length > 0) {
                setQcList(qcInspectors.filter((member: any) => member.userId === currentUserTeamMemberId));
            }
            else {
                setQcList([]);
            }

            if (isAdminOrSuperAdmin) {
                setCustomerRepresentativeList(customerReps);
            }
            else if (isCustomerRepresentativeUser && customerReps.length > 0) {
                setCustomerRepresentativeList(customerReps.filter((member: any) => member.userId === currentUserTeamMemberId));
            }
            else {
                setCustomerRepresentativeList([]);
            }

        } else {
            console.log('No team members available');
        }
    }

    // Log team members when they change
    useEffect(() => {
        loadtetAllTeamMembers();
    }, [teamMembers]);

    const handleFitmentStateChange = (newState: any, weldIndex: number) => {
        if (weldIndex === 0 && fitmentWeld1Data) {
            // Create a new object reference to trigger re-render
            // The Fitment component mutates the object directly, so spreading captures those changes
            setFitmentWeld1Data({ ...fitmentWeld1Data });
        } else if (weldIndex === 1 && fitmentWeld2Data) {
            // Create a new object reference to trigger re-render
            setFitmentWeld2Data({ ...fitmentWeld2Data });
        }
        setHasUnsavedChanges(true);
    };

    const handleVisualInspectionStateChange = (newState: any, weldIndex: number) => {
        if (weldIndex === 0 && visualInspectionWeld1Data) {
            // Create a new object reference to trigger re-render
            setVisualInspectionWeld1Data({ ...visualInspectionWeld1Data });
        } else if (weldIndex === 1 && visualInspectionWeld2Data) {
            // Create a new object reference to trigger re-render
            setVisualInspectionWeld2Data({ ...visualInspectionWeld2Data });
        }
        setHasUnsavedChanges(true);
    };

    const handleAlignmentStateChange = (newState: any, weldIndex: number) => {
        // Create a new object reference to trigger re-render
        if (alignmentWeldData) {
            setAlignmentWeldData({ ...alignmentWeldData });
        }
        setHasUnsavedChanges(true);
    };

    const handleSave = async () => {
        try {
            setIsSaveLoading(true);
            if (type === 'fitment') {
                // Save both weld fitment data
                const promises = [];

                if (fitmentWeld1Data && activeTab === 'weld1') {
                    fitmentWeld1Data.WeldSave = false;
                    promises.push(dispatch(updateAssemblyFitment(fitmentWeld1Data)));
                }

                if (fitmentWeld2Data && activeTab === 'weld2') {
                    fitmentWeld2Data.WeldSave = true;
                    promises.push(dispatch(updateAssemblyFitment(fitmentWeld2Data)));
                }

                await Promise.all(promises);
                setHasUnsavedChanges(false);
                // Reload production data after successful save
                //  await loadProductionData();
                // Re-check signatures after save - data will be updated via Redux
                // Edit mode will be updated by the useEffect that watches for data changes

            } else if (type === 'visualInspection') {
                // Save both weld visual inspection data
                const promises = [];

                if (visualInspectionWeld1Data && activeTab === 'weld1') {
                    visualInspectionWeld1Data.WeldSave = false;
                    promises.push(dispatch(updateAssemblyVisualInspection(visualInspectionWeld1Data)));
                }

                if (visualInspectionWeld2Data && activeTab === 'weld2') {
                    visualInspectionWeld2Data.WeldSave = true;
                    promises.push(dispatch(updateAssemblyVisualInspection(visualInspectionWeld2Data)));
                }

                await Promise.all(promises);
                setHasUnsavedChanges(false);
                // Reload production data after successful save
                //  await loadProductionData();
                // Re-check signatures after save - data will be updated via Redux
                // Edit mode will be updated by the useEffect that watches for data changes

            } else if (type === 'alignment') {
                // Save alignment data
                let alignmentData = alignmentWeldData;
                
                // If no alignmentWeldData, get from productionSheetData based on selection
                if (!alignmentData) {
                    if (selectedRepairAlignment === 'default') {
                        alignmentData = productionSheetData?.productionAlignment;
                    } else {
                        const repairIndex = Number(selectedRepairAlignment);
                        alignmentData = productionSheetData?.productionRepairAlignments?.find(
                            (ra: any) => ra.repairindex === repairIndex
                        );
                    }
                }

                if (alignmentData) {
                    await dispatch(updateAssemblyAlignment(alignmentData));
                    setHasUnsavedChanges(false);
                    // Reload production data after successful save
                    //await loadProductionData();
                    // Re-check signatures after save - data will be updated via Redux
                    // Edit mode will be updated by the useEffect that watches for data changes
                }
            }
        } catch (error) {
            customNotification.error('Failed to save data. Please try again.');
        } finally {
        }
    };

    const handleEdit = () => {
        setShowEditConfirmation(true);
    };

    const handleConfirmEdit = () => {
        setShowEditConfirmation(false);
        setIsEditMode(true);

        // Clear signatures when entering edit mode
        if (type === 'fitment') {
            if (fitmentWeld1Data && activeTab === 'weld1') {
                const updatedData = { ...fitmentWeld1Data };
                updatedData.signature = null
                setFitmentWeld1Data(updatedData);
            }
            if (fitmentWeld2Data && activeTab === 'weld2') {
                const updatedData = { ...fitmentWeld2Data };
                updatedData.signature = null;
                setFitmentWeld2Data(updatedData);
            }
        } else if (type === 'visualInspection') {
            if (visualInspectionWeld1Data && activeTab === 'weld1') {
                const updatedData = { ...visualInspectionWeld1Data };
                updatedData.signature = null;
                setVisualInspectionWeld1Data(updatedData);
            }
            if (visualInspectionWeld2Data && activeTab === 'weld2') {
                const updatedData = { ...visualInspectionWeld2Data };
                updatedData.signature = null;
                setVisualInspectionWeld2Data(updatedData);
            }
        } else if (type === 'alignment') {
            if (alignmentWeldData) {
                const updatedData = { ...alignmentWeldData };
                updatedData.signature = null;
                setAlignmentWeldData(updatedData);
            }
        }

        // Mark as having unsaved changes after clearing signatures
        // setHasUnsavedChanges(true);
    };

    const handleCancelEdit = () => {
        setShowEditConfirmation(false);
        // Stay in view mode (isEditMode remains false)
    };

    const handleClose = () => {
        if (hasUnsavedChanges) {
            setShowCloseConfirmation(true);
        } else {
            // Reset modal state when closing
            setActiveTab('weld1');
            setHasUnsavedChanges(false);
            setIsEditMode(false);
            onClose();
        }
    };
    const handleSaveAndClose = async () => {
        await handleSave();
        setActiveTab('weld1');
        setHasUnsavedChanges(false);
        onClose();
    };

    const handleConfirmClose = () => {
        setShowCloseConfirmation(false);
        setHasUnsavedChanges(false);
        setIsEditMode(false);
        onClose();
    };

    const getModalTitle = () => {
        if (type === 'fitment') return 'Fitment Data';
        if (type === 'visualInspection') return 'Visual Inspection Data';
        if (type === 'alignment') return 'Alignment Data';
        return 'Production Data';
    };

    const getSaveButtonLoading = () => {
        if (type === 'fitment') return fitmentUpdateLoading;
        if (type === 'visualInspection') return visualInspectionUpdateLoading;
        if (type === 'alignment') return alignmentUpdateLoading;
        return false;
    };

    // Helper function to check if signatures exist
    const hasSignatures = () => {

        if (type === 'fitment') {
            // Use getCurrentWeldData so repair welds are also checked correctly
            const activeWeldData = getCurrentWeldData(activeTab);
            return !!(activeWeldData?.signature?.qc?.signature && activeWeldData?.signature?.customer?.signature);
        } else if (type === 'visualInspection') {
            const activeWeldData = getCurrentWeldData(activeTab);
            return !!(activeWeldData?.signature?.qc?.signature && activeWeldData?.signature?.customer?.signature);
        } else if (type === 'alignment') {
            return !!(alignmentWeldData?.signature?.qc?.signature && alignmentWeldData?.signature?.customer?.signature);
        }
        return false;
    };

    // Handle download fitment report
    const handleDownloadFitmentReport = async (_weldData?: any) => {
        setIsReportLoading(true);
        // Always resolve from the currently selected repair weld (or default weld)
        const weldData = getCurrentWeldData(activeTab);
        // Validate required data
        if (!selectedItem?.projectId || !selectedPipe?.projectId) {
            customNotification.error('Project ID not found');
            return;
        }
        if (!selectedItem?.pipeId || !selectedPipe?.pipeId) {
            customNotification.error('Pipe ID not found');
            return;
        }
        if (!weldData?.productionId) {
            customNotification.error('Production ID not found');
            return;
        }
        if (!weldData?.productionWeldFitmentId) {
            customNotification.error('Fitment ID not found');
            return;
        }
        if (!weldData?.productionWeldId) {
            customNotification.error('Weld ID not found');
            return;
        }
        console.log('weldData', weldData);

        const payload = {
            projectId: selectedItem.projectId || selectedPipe.projectId,
            pipeId: selectedItem.pipeId || selectedPipe.pipeId,
            productionId: weldData.productionId,
            productionWeldFitmentId: weldData.productionWeldFitmentId,
            productionWeldId: weldData.productionWeldId
        };

        //    // Dispatch action to set loading state
        //        dispatch(downloadFitmentReport(payload));

        // Call API directly and handle download in .then()
        try {
            const params = new URLSearchParams({
                projectId: payload.projectId.toString(),
                pipeId: payload.pipeId.toString(),
                productionId: payload.productionId.toString(),
                productionWeldFitmentId: payload.productionWeldFitmentId.toString(),
                productionWeldId: payload.productionWeldId.toString()
            });

            const url = `/download-proxy/reports/joint-fit-up-inspection?${params.toString()}`;
         //  const url = `/reports/joint-fit-up-inspection?${params.toString()}`;
            const res = await axiosConfig.get(url);

            if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {


                loadProductionData();
                // // Download the PDF by opening in new tab
                // const link = document.createElement('a');
                // link.href = res.data.data.downloadUrl;
                // link.target = '_blank';
                // link.rel = 'noopener noreferrer';
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
            } else {
                customNotification.error('Failed to generate report');
            }
        } catch (error) {
            customNotification.error('Error downloading report');
        } finally {
            // Clear download state
            dispatch(clearFitmentReportDownload());
            setIsReportLoading(false);
        }
    };

    // Handle download visual inspection report
    const handleDownloadVisualInspectionReport = async (_weldData?: any) => {
        setIsReportLoading(true);
        // Always resolve from the currently selected repair weld (or default weld)
        const weldData = getCurrentWeldData(activeTab);
        // The correct path is productionWeldVisualInspectionId
        const inspectionId = weldData?.productionWeldVisualInspectionId;

        // Validate required data
        if (!inspectionId) {
            customNotification.error('Visual Inspection ID not found');
            return;
        }

        const payload = {
            productionWeldInspectionId: inspectionId
        };

        // Dispatch action to set loading state
        // dispatch(downloadVisualInspectionReport(payload));

        // Call API directly and handle download in .then()
        try {
            const params = new URLSearchParams({
                productionWeldInspectionId: inspectionId.toString()
            });

           const url = `/download-proxy/reports/visualInspection?${params.toString()}`;
           // const url = `/reports/visualInspection?${params.toString()}`;
            const res = await axiosConfig.get(url);

            if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
                // Download the PDF by opening in new tab
                loadProductionData();
            } else {
                customNotification.error('Failed to generate report');
            }
        } catch (error) {
            customNotification.error('Error downloading report');
        } finally {
            // Clear download state
            dispatch(clearVisualInspectionReportDownload());
            setIsReportLoading(false);
        }
    };

    // Handle download alignment report
    const handleDownloadAlignmentReport = async () => {
        setIsReportLoading(true);
        // Alignment uses alignmentWeldData which is already updated when repair alignment is selected
        const weldData = alignmentWeldData || productionSheetData?.productionAlignment;
        // Validate required data
        if (!selectedItem?.projectId || !selectedPipe?.projectId) {
            customNotification.error('Project ID not found');
            return;
        }
        if (!selectedItem?.pipeId || !selectedPipe?.pipeId) {
            customNotification.error('Pipe ID not found');
            return;
        }
        if (!alignmentWeldData?.productionId && !productionSheetData?.productionId) {
            customNotification.error('Production ID not found');
            return;
        }
        if (!weldData?.productionWeldAlignmentId) {
            customNotification.error('Alignment ID not found');
            return;
        }

        const payload = {
            projectId: selectedItem.projectId || selectedPipe.projectId,
            pipeId: selectedItem.pipeId || selectedPipe.pipeId,
            productionId: alignmentWeldData?.productionId || productionSheetData?.productionId,
            productionWeldAlignmentId: weldData.productionWeldAlignmentId
        };

        // Dispatch action to set loading state
        // dispatch(downloadAlignmentReport(payload));

        // Call API directly and handle download in .then()
        try {
            const params = new URLSearchParams({
                projectId: payload.projectId.toString(),
                pipeId: payload.pipeId.toString(),
                productionId: payload.productionId.toString(),
                productionWeldAlignmentId: payload.productionWeldAlignmentId.toString()
            });

            const url = `/download-proxy/reports/alignment-verification?${params.toString()}`;
           // const url = `/reports/alignment-verification?${params.toString()}`;
            const res = await axiosConfig.get(url);

            if (res.status === 200 && res.data.success === 1 && res.data.data?.downloadUrl) {
                loadProductionData();
            } else {
                customNotification.error('Failed to generate report');
            }
        } catch (error) {
            customNotification.error('Error downloading report');
        } finally {
            // Clear download state
            dispatch(clearAlignmentReportDownload());
            setIsReportLoading(false);
        }
    };

    // Get current weld data based on selected repair weld
    const getCurrentWeldData = (tab?: 'weld1' | 'weld2') => {
        const currentTab = tab || activeTab;
        const tabWeldIndex = currentTab === 'weld1' ? 1 : 2;

        if (selectedRepairWeld === 'default') {
            // Return default weld data
            if (currentTab === 'weld1') {
                const defaultData = type === 'fitment' ? fitmentWeld1Data : visualInspectionWeld1Data;
                // Ensure details exists for fitment
                if (type === 'fitment' && defaultData && !defaultData.details) {
                    defaultData.details = {};
                }
                return defaultData;
            } else {
                const defaultData = type === 'fitment' ? fitmentWeld2Data : visualInspectionWeld2Data;
                // Ensure details exists for fitment
                if (type === 'fitment' && defaultData && !defaultData.details) {
                    defaultData.details = {};
                }
                return defaultData;
            }
        } else {
            // Parse selected repair weld (format: "weldindex-repairindex")
            const [weldIndex, repairIndex] = selectedRepairWeld.split('-').map(Number);

            // If this repair belongs to a different tab's weld, fall back to default data
            if (weldIndex !== tabWeldIndex) {
                const defaultData = currentTab === 'weld1'
                    ? (type === 'fitment' ? fitmentWeld1Data : visualInspectionWeld1Data)
                    : (type === 'fitment' ? fitmentWeld2Data : visualInspectionWeld2Data);
                if (type === 'fitment' && defaultData && !defaultData.details) {
                    defaultData.details = {};
                }
                return defaultData;
            }

            const repairWeld = productionSheetData?.productionWelds?.find(
                (w: any) => w.weldindex === weldIndex && w.repairindex === repairIndex
            );

            if (repairWeld) {
                if (type === 'fitment') {
                    if (repairWeld.weldFitment) {
                        // Ensure details object exists
                        if (!repairWeld.weldFitment.details) {
                            repairWeld.weldFitment.details = {};
                        }
                        return {
                            ...repairWeld.weldFitment,
                            productionId: productionSheetData.productionId,
                            productionWeldId: repairWeld.productionWeldId
                        };
                    } else {
                        // Return empty structure with details object for new fitment data
                        return {
                            productionId: productionSheetData.productionId,
                            productionWeldId: repairWeld.productionWeldId,
                            details: {},
                            fitmentReadings: []
                        };
                    }
                } else if (type === 'visualInspection') {
                    return repairWeld.weldVisualInspection ? {
                        ...repairWeld.weldVisualInspection,
                        productionId: productionSheetData.productionId,
                        productionWeldId: repairWeld.productionWeldId
                    } : {
                        productionId: productionSheetData.productionId,
                        productionWeldId: repairWeld.productionWeldId
                    };
                }
            }
            // Return default structure if repair weld not found
            if (type === 'fitment') {
                return {
                    details: {},
                    fitmentReadings: []
                };
            }
            return {};
        }
    };

    const getCurrentWeldIndex = () => {
        if (selectedRepairWeld === 'default') {
            return activeTab === 'weld1' ? 0 : 1;
        } else {
            const [weldIndex] = selectedRepairWeld.split('-').map(Number);
            return weldIndex - 1; // Convert to 0-based index
        }
    };

    const getSelectedItemProductionSheet = () => {
        return productionSheetData || selectedItem?.productionSheet;
    }

    // File type detection utilities
    const getFileExtension = (fileName?: string, fileUrl?: string) => {
        const name = fileName || fileUrl?.split('?')[0].split('/').pop() || '';
        return name.split('.').pop()?.toLowerCase() || '';
    };

    const getViewerType = (file: any): 'pdf' | 'media' | 'document' => {
        const ext = getFileExtension(file?.fileName, file?.fileUrl);
        if (ext === 'pdf') return 'pdf';
        const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'bmp', 'tiff', 'tif'];
        const videoExts = ['mp4', 'avi', 'mov', 'wmv', 'webm'];
        if (imageExts.includes(ext) || videoExts.includes(ext)) return 'media';
        return 'document'; // Default for office docs and fallback
    };

    // Unified viewer handler
    const openViewer = (fileOrFiles: any | any[]) => {

        if (!fileOrFiles) return;

        // Handle array of files
        if (Array.isArray(fileOrFiles)) {
            const validFiles = fileOrFiles.filter((f: any) => f?.fileUrl || f?.file_url);
            if (validFiles.length === 0) {
                customNotification.error('No valid files to view');
                return;
            }

            // Check if all files are media (images/videos)
            const allMedia = validFiles.every((file: any) => getViewerType(file) === 'media');

            if (allMedia && validFiles.length > 1) {
                // Multiple media files - use MediaViewer
                setViewerFiles(validFiles);
                setViewerType('media');
                setViewerFile(null);
            } else {
                // Single file or mixed types - open first file
                openViewer(validFiles[0]);
            }
            return;
        }

        // Handle single file
        const file = fileOrFiles;
        if (!file?.fileUrl && !file?.file_url) {
            customNotification.error('File URL not available');
            return;
        }

        // Normalize file object to ensure fileUrl exists
        const normalizedFile = {
            ...file,
            fileUrl: file.fileUrl || file.file_url || file.url,
            fileName: file.fileName || file.file_name || file.name
        };

        const type = getViewerType(normalizedFile);
        setViewerType(type);

        if (type === 'media') {
            // For media, use array format for MediaViewer
            setViewerFiles([normalizedFile]);
            setViewerFile(null);
        } else {
            // For PDF and documents, use single file
            setViewerFile(normalizedFile);
            setViewerFiles([]);
        }
    };

    const closeViewer = () => {
        // console.log('closeViewer triggered');
        setViewerType(null);
        setViewerFile(null);
        setViewerFiles([]);
    };

    // Check if any viewer is active
    const isViewerOpen = viewerType !== null && (viewerFile !== null || viewerFiles.length > 0);

    // If viewer is open, render ONLY the viewer (not the Dialog) to avoid focus trap issues
    if (isViewerOpen) {
        return (
            <>
                {/* PDF Viewer */}
                {viewerType === 'pdf' && viewerFile && (
                    <PdfViewer
                        fileUrl={viewerFile.fileUrl}
                        fileName={viewerFile.fileName}
                        onClose={closeViewer}
                    />
                )}

                {/* Media Viewer */}
                {viewerType === 'media' && viewerFiles.length > 0 && (
                    <MediaViewer
                        files={viewerFiles}
                        initialIndex={0}
                        onClose={closeViewer}
                    />
                )}

                {/* Document Viewer */}
                {viewerType === 'document' && viewerFile && (
                    <DocumentViewer
                        document={viewerFile}
                        onClose={closeViewer}
                    />
                )}
            </>
        );
    }

    return (
        <>
            <Dialog open={isOpen} onOpenChange={handleClose}>
                <DialogContent className="w-screen h-screen max-w-none max-h-none p-0 flex flex-col [&>button]:hidden"
                    style={{ width: '100vw', height: '100vh', maxWidth: 'none' }}>
                    <DialogHeader className="px-6 py-4 border-b flex-shrink-0">
                        <div className="flex items-center justify-between">
                            <Button
                                onClick={handleClose}
                                className="hover:bg-gray-100 p-2 rounded-lg transition-colors"
                                title="Go back"
                                variant="outline"
                            >
                                <ChevronLeft className="h-5 w-5" />
                            </Button>
                            <DialogTitle className="text-xl font-semibold flex-1 p-2 text-left">
                                {getModalTitle()} - {selectedItem?.assemblyNumber}
                            </DialogTitle>
                            <div className="w-10"></div>
                        </div>
                    </DialogHeader>

                    {isLoadingData ? (
                        <div className="flex justify-center items-center h-full">
                            <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
                        </div>
                    ) : (
                        type === 'alignment' ? (
                            <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
                                <div className="px-6 py-4 border-b flex-shrink-0">
                                    {productionSheetData?.productionRepairAlignments && productionSheetData.productionRepairAlignments.length > 0 && (
                                        <Select
                                            value={selectedRepairAlignment}
                                            onValueChange={(value) => {
                                                setSelectedRepairAlignment(value);
                                                // Update alignment data based on selection
                                                if (value === 'default') {
                                                    // Load default alignment - use UpdateAlignmentData to ensure proper structure
                                                    if (productionSheetData?.productionAlignment) {
                                                        const defaultAlignment = UpdateAlignmentData(productionSheetData);
                                                        setAlignmentWeldData(defaultAlignment);
                                                    } else {
                                                        setAlignmentWeldData(null);
                                                    }
                                                } else {
                                                    console.log('value', value);
                                                    UpdateRepairAlignmentData(0, parseInt(value));
                                                }
                                            }}
                                        >
                                            <SelectTrigger className="w-[300px] h-9">
                                                <SelectValue placeholder="Select repair alignment..." />
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectItem value="default">Default Alignment</SelectItem>
                                                {productionSheetData?.productionRepairAlignments && productionSheetData.productionRepairAlignments.length > 0 && productionSheetData.productionRepairAlignments
                                                    .filter((ra: any) => ra.repairindex > 0) // Filter out index 0 (default)
                                                    .map((repairAlignment: any) => (
                                                        <SelectItem
                                                            key={`repair-${repairAlignment.repairindex}`}
                                                            value={repairAlignment.repairindex?.toString()}
                                                        >
                                                            Repair {repairAlignment.repairindex} Alignment
                                                        </SelectItem>
                                                    ))}
                                            </SelectContent>
                                        </Select>
                                    )}
                                </div>
                                <div className="flex-1 overflow-y-auto p-6 min-h-0 max-h-full">
                                    <Alignment
                                        selectedItem={selectedItem}
                                        selectedPipe={selectedPipe}
                                        materials={materials}
                                        specifications={specifications}
                                        alignmentWeldData={alignmentWeldData || productionSheetData?.productionAlignment}
                                        alignmentState={{} }
                                        onAlignmentStateChange={(newState: any) => handleAlignmentStateChange(newState, 0)}
                                        customerRepresentativeList={customerRepresentativeList}
                                        qcList={qcList}
                                        onDownloadReport={handleDownloadAlignmentReport}
                                        downloadLoading={alignmentReportDownloadLoading}
                                        isEditMode={isEditMode}
                                        canSign={canSign}
                                        isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                                        isQCInspectorUser={isQCInspectorUser}
                                        isWelderUser={false}
                                        currentUserTeamMemberId={currentUserTeamMemberId}
                                        isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
                                <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
                                        <Tabs value={activeTab} onValueChange={(value) => {
                                                setActiveTab(value as 'weld1' | 'weld2');
                                                setSelectedRepairWeld('default');
                                            }} className="flex-1 flex flex-col h-full">
                                        <div className="px-6 py-4 border-b flex-shrink-0">
                                            <TabsList className="h-12 w-full justify-between gap-8 border-b border-gray-200 bg-transparent px-4 py-2">
                                                <div className="flex items-center gap-8">
                                                    <TabsTrigger
                                                        value="weld1"
                                                        className="data-[state=active]:border-[#EB1C37] data-[state=active]:text-[#EB1C37] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                                                    >
                                                        Weld 1
                                                    </TabsTrigger>
                                                    <TabsTrigger
                                                        value="weld2"
                                                        className="data-[state=active]:border-[#EB1C37] data-[state=active]:text-[#EB1C37] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                                                    >
                                                        Weld 2
                                                    </TabsTrigger>
                                                </div>
                                                {productionSheetData?.productionWelds && productionSheetData?.productionWelds.length > 2 && (<Select
                                                    value={selectedRepairWeld}
                                                    onValueChange={(value) => {
                                                        setSelectedRepairWeld(value);
                                                    }}
                                                >
                                                    <SelectTrigger className="w-[300px] h-9">
                                                        <SelectValue placeholder="Select repair..." />
                                                    </SelectTrigger>
                                                    <SelectContent>
                                                        <SelectItem value="default">Default Weld</SelectItem>
                                                        {productionSheetData?.productionWelds
                                                            ?.filter((weld: any) => {
                                                                const weldIndex = activeTab === 'weld1' ? 1 : 2;
                                                                return weld.weldindex === weldIndex && weld.repairindex && weld.repairindex > 0;
                                                            })
                                                            .map((repairWeld: any) => (
                                                                <SelectItem
                                                                    key={`${repairWeld.weldindex}-${repairWeld.repairindex}`}
                                                                    value={`${repairWeld.weldindex}-${repairWeld.repairindex}`}
                                                                >
                                                                    Repair {repairWeld.repairindex} - {repairWeld.weldName || `Repair ${repairWeld.repairindex}`}
                                                                </SelectItem>
                                                            ))}
                                                    </SelectContent>
                                                </Select>
                                                )}
                                            </TabsList>
                                        </div>

                                        <div className="flex-1 overflow-y-auto p-6 min-h-0 max-h-full">
                                            <TabsContent value="weld1" className="mt-0 h-full overflow-y-auto">
                                                {(() => {
                                                    const currentData = getCurrentWeldData('weld1');
                                                    const currentWeld = selectedRepairWeld !== 'default'
                                                        ? (() => {
                                                            const [weldIndex, repairIndex] = selectedRepairWeld.split('-').map(Number);
                                                            // weld1 tab → weldindex must be 1
                                                            return weldIndex === 1
                                                                ? productionSheetData?.productionWelds?.find((w: any) => w.weldindex === weldIndex && w.repairindex === repairIndex)
                                                                : productionSheetData?.productionWelds?.[0];
                                                        })()
                                                        : productionSheetData?.productionWelds?.[0];

                                                  

                                                    return type === 'fitment' && currentData?.productionWeldFitmentId ? (
                                                        <Fitment
                                                            selectedItem={selectedItem}
                                                            selectedPipe={selectedPipe}
                                                            materials={materials}
                                                            specifications={specifications}
                                                            fitmentWeldData={currentData}
                                                            fitmentState={currentData}
                                                            onFitmentStateChange={(newState) => handleFitmentStateChange(newState, 0)}
                                                            customerRepresentativeList={customerRepresentativeList}
                                                            qcList={qcList}
                                                            selectedHeadings={mockSelectedHeadings}
                                                            selectedWeld={0}
                                                            onDownloadReport={() => currentData && handleDownloadFitmentReport(currentData)}
                                                            downloadLoading={fitmentReportDownloadLoading}
                                                            isEditMode={isEditMode}
                                                            canSign={canSign}
                                                            isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                                                            isQCInspectorUser={isQCInspectorUser}
                                                            isWelderUser={false}
                                                            currentUserTeamMemberId={currentUserTeamMemberId}
                                                            isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                                                        />
                                                    ) : (
                                                      type === 'visualInspection' && currentData && currentData?.productionWeldVisualInspectionId && <VisualInspection
                                                            selectedItem={selectedItem}
                                                            selectedPipe={selectedPipe}
                                                            materials={materials}
                                                            specifications={specifications}
                                                            visualInspectionWeldData={currentData}
                                                            visualInspectionState={currentData}
                                                            onVisualInspectionStateChange={(newState) => handleVisualInspectionStateChange(newState, 0)}
                                                            weldData={currentWeld || null}
                                                            customerRepresentativeList={customerRepresentativeList}
                                                            qcList={qcList}
                                                            onDownloadReport={() => handleDownloadVisualInspectionReport(currentData)}
                                                            downloadLoading={visualInspectionReportDownloadLoading}
                                                            isEditMode={isEditMode}
                                                            canSign={canSign}
                                                            isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                                                            isQCInspectorUser={isQCInspectorUser}
                                                            currentUserTeamMemberId={currentUserTeamMemberId}
                                                            isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                                                        />
                                                    );
                                                })()}
                                            </TabsContent>

                                            <TabsContent value="weld2" className="mt-0 h-full overflow-y-auto">
                                                {(() => {
                                                    const currentData = getCurrentWeldData('weld2');
                                                    const currentWeld = selectedRepairWeld !== 'default'
                                                        ? (() => {
                                                            const [weldIndex, repairIndex] = selectedRepairWeld.split('-').map(Number);
                                                            // weld2 tab → weldindex must be 2
                                                            return weldIndex === 2
                                                                ? productionSheetData?.productionWelds?.find((w: any) => w.weldindex === weldIndex && w.repairindex === repairIndex)
                                                                : productionSheetData?.productionWelds?.[1];
                                                        })()
                                                        : productionSheetData?.productionWelds?.[1];

                                                    return type === 'fitment' ? (
                                                        type === 'fitment' && currentData && currentData?.productionWeldFitmentId && <Fitment
                                                            selectedItem={selectedItem}
                                                            selectedPipe={selectedPipe}
                                                            materials={materials}
                                                            specifications={specifications}
                                                            fitmentWeldData={currentData}
                                                            fitmentState={currentData}
                                                            onFitmentStateChange={(newState) => handleFitmentStateChange(newState, 1)}
                                                            customerRepresentativeList={customerRepresentativeList}
                                                            qcList={qcList}
                                                            selectedHeadings={mockSelectedHeadings}
                                                            selectedWeld={1}
                                                            onDownloadReport={() => currentData && handleDownloadFitmentReport(currentData)}
                                                            downloadLoading={fitmentReportDownloadLoading}
                                                            isEditMode={isEditMode}
                                                            canSign={canSign}
                                                            isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                                                            isQCInspectorUser={isQCInspectorUser}
                                                            isWelderUser={false}
                                                            currentUserTeamMemberId={currentUserTeamMemberId}
                                                            isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                                                        />
                                                    ) : (
                                                        type === 'visualInspection' && currentData && currentData?.productionWeldVisualInspectionId && <VisualInspection
                                                            selectedItem={selectedItem}
                                                            selectedPipe={selectedPipe}
                                                            materials={materials}
                                                            specifications={specifications}
                                                            visualInspectionWeldData={currentData}
                                                            visualInspectionState={currentData}
                                                            onVisualInspectionStateChange={(newState) => handleVisualInspectionStateChange(newState, 1)}
                                                            weldData={currentWeld || null}
                                                            customerRepresentativeList={customerRepresentativeList}
                                                            qcList={qcList}
                                                            onDownloadReport={() => handleDownloadVisualInspectionReport(currentData)}
                                                            downloadLoading={visualInspectionReportDownloadLoading}
                                                            isEditMode={isEditMode}
                                                            canSign={canSign}
                                                            isCustomerRepresentativeUser={isCustomerRepresentativeUser}
                                                            isQCInspectorUser={isQCInspectorUser}
                                                            isWelderUser={false}
                                                            currentUserTeamMemberId={currentUserTeamMemberId}
                                                            isAdminOrSuperAdmin={isAdminOrSuperAdmin}
                                                        />
                                                    );
                                                })()}
                                            </TabsContent>
                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                        )
                    )}
                    <div className="px-6 py-4 border-t bg-gray-50 flex-shrink-0">
                        <div className="flex justify-end gap-3">
                            <Button
                                variant="outline"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            {canEdit && !isEditMode && hasSignatures() && (
                                <Button
                                    variant="outline"
                                    onClick={handleEdit}
                                    disabled={isEditMode}
                                >
                                    Edit
                                </Button>
                            )}

                            <Button
                                // variant="outline"
                                onClick={() => setIsDocumentApprovalModalOpen(true)}
                                className="flex items-center gap-2"
                                loading={isReportLoading}
                                loadingText="Generating..."
                                disabled={isReportLoading}
                            >
                                Download Report

                            </Button>
                            {canReport && type === 'fitment' && (
                                <Button
                                    onClick={() => handleDownloadFitmentReport(activeTab === 'weld1' ? fitmentWeld1Data : fitmentWeld2Data)}
                                    className="px-4 py-2 text-white bg-hero-red rounded-lg hover:bg-hero-red-60"
                                    variant="default"
                                    loading={isReportLoading}
                                    loadingText="Generating..."
                                    disabled={isReportLoading || hasUnsavedChanges || !hasSignatures()}
                                >
                                    <Download className="h-4 w-4 mr-2" />
                                    Generate Report
                                </Button>
                            )}
                            {canReport && type === 'visualInspection' && (
                                <Button
                                    onClick={() => handleDownloadVisualInspectionReport(activeTab === 'weld1' ? visualInspectionWeld1Data : visualInspectionWeld2Data)}
                                    className="px-4 py-2 text-white bg-hero-red rounded-lg hover:bg-hero-red-60"
                                    variant="default"
                                    loading={visualInspectionReportDownloadLoading}
                                    loadingText="Generating..."
                                    disabled={!hasSignatures() || visualInspectionReportDownloadLoading || hasUnsavedChanges}
                                >
                                    <Download className="h-4 w-4 mr-2" />
                                    Generate Report
                                </Button>
                            )}
                            {canReport && type === 'alignment' && (
                                <Button
                                    onClick={handleDownloadAlignmentReport}
                                    className="px-4 py-2 text-white bg-hero-red rounded-lg hover:bg-hero-red-60"
                                    variant="default"
                                    loading={alignmentReportDownloadLoading}
                                    loadingText="Generating..."
                                    disabled={alignmentReportDownloadLoading || hasUnsavedChanges || !hasSignatures()}
                                >
                                    <Download className="h-4 w-4 mr-2" />
                                    Generate Report
                                </Button>
                            )}

                            <Button
                                onClick={handleSave}
                                disabled={!hasUnsavedChanges}
                                loading={getSaveButtonLoading()}
                                loadingText="Saving..."
                                className="bg-hero-red hover:bg-hero-red-60 text-white"
                            >
                                <Save className="h-4 w-4 mr-2" />
                                Save
                            </Button>

                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            {/* Unsaved Changes Confirmation Dialog */}
            <Dialog open={showCloseConfirmation} onOpenChange={setShowCloseConfirmation}>
                <DialogContent className="max-w-[700px] p-6">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="flex-shrink-0 w-10 h-10 bg-hero-red-10 rounded-full flex items-center justify-center">
                            <AlertTriangle className="h-5 w-5 text-hero-red" />
                        </div>
                        <DialogTitle className="font-heading text-[18px] font-semibold text-blueprint-blue leading-tight">
                            Unsaved Changes
                        </DialogTitle>
                    </div>
                    <div>
                        <p className="text-[13px] leading-5 text-text-grey mb-3">
                            You have unsaved changes in the 'Fitment' . What would you like to do?
                        </p>
                        <div className="mt-4 p-3 bg-hero-red-10 border border-hero-red-20 rounded-md">
                            <p className="text-[13px] leading-5 text-readable-red">
                                <span className="font-semibold">Note:</span> Choose "Save" to keep your changes, "Discard" to discard changes and close, or "Cancel" to stay on this page.
                            </p>
                        </div>
                    </div>
                    <DialogFooter className="gap-3">
                        <Button
                            variant="outline"
                            onClick={() => setShowCloseConfirmation(false)}
                            className="min-w-[100px]"
                        >
                            Cancel
                        </Button>

                        <Button
                            onClick={handleSaveAndClose}
                            className="min-w-[100px]"
                            loading={
                                fitmentUpdateLoading
                            }
                            loadingText="Saving..."
                            disabled={!hasUnsavedChanges}
                        >
                            <Save className="h-4 w-4 mr-2" />
                            Save
                        </Button>
                        <Button
                            onClick={handleConfirmClose}
                            className="min-w-[100px] bg-hero-red hover:bg-hero-red-60 text-white"
                        >
                            <div className="flex items-center gap-2">
                                <AlertTriangle className="h-4 w-4" />
                                Discard
                            </div>
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            {/* Edit Confirmation Dialog - Shows when Edit button is clicked */}
            <Dialog open={showEditConfirmation} onOpenChange={setShowEditConfirmation}>
                <DialogContent className="max-w-[700px] p-6">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="flex-shrink-0 w-10 h-10 bg-hero-red-10 rounded-full flex items-center justify-center">
                            <AlertTriangle className="h-5 w-5 text-hero-red" />
                        </div>
                        <DialogTitle className="font-heading text-[18px] font-semibold text-blueprint-blue leading-tight">
                            Edit Mode Confirmation
                        </DialogTitle>
                    </div>
                    <div>
                        <p className="text-[13px] leading-5 text-text-grey mb-3">
                            If you make any changes, please add signatures after editing.
                        </p>
                        <div className="mt-4 p-3 bg-hero-red-10 border border-hero-red-20 rounded-md">
                            <p className="text-[13px] leading-5 text-readable-red">
                                <span className="font-semibold">Note:</span> After editing, you will need to add QC and Customer signatures before saving. Click "Yes" to proceed to edit mode, or "No" to stay in view mode.
                            </p>
                        </div>
                    </div>
                    <DialogFooter className="gap-3">
                        <Button
                            variant="outline"
                            onClick={handleCancelEdit}
                            className="min-w-[100px]"
                        >
                            No
                        </Button>
                        <Button
                            variant="default"
                            onClick={handleConfirmEdit}
                            className="min-w-[100px] bg-hero-red hover:bg-hero-red-60 text-white"
                        >
                            Yes
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>


            {/* Document Approval Modal */}
            {isDocumentApprovalModalOpen && productionSheetData && (
                <DocumentApprovalModal
                    isOpen={isDocumentApprovalModalOpen}
                    onClose={() => setIsDocumentApprovalModalOpen(false)}
                    onOpenViewer={openViewer}
                    productionSheetData={getSelectedItemProductionSheet()}
                    selectedPipe={selectedPipe}
                    assemblyNumber={selectedItem?.assemblyNumber}
                    onDownloadMergedReport={async () => { }}
                    onStatusChange={() => { }}
                    onRefresh={loadProductionData}
                    isFitmentreport={type === 'fitment'}
                    isVisualInspectionreport={type === 'visualInspection'}
                    isAlignmentreport={type === 'alignment'}
                    isProductionSheetreport={false}
                    isNDTreport={false}
                    isCoatingreport={false}
                    isMergeProductionReport={false}
                    isMergeReport={false}
                    isVissibleApprovalButton={false}
                />
            )}
        </>
    );
}
